export default __webpack_public_path__ + "static/media/hall-map.fee99c48.png";